import { createAsyncThunk } from "@reduxjs/toolkit";
import * as facilityApi from '../../utils/api/facilityApi';


export const fetchFacility = createAsyncThunk(
    'facility/fetchFacility',
    async(_, {rejectWithValue}) => {
        try {
            return await facilityApi.fetchFacility();
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message)
        }
    }
)